import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Upload, Button, Row, Col, Typography, App } from "antd";
import { COMPONENT_BORDER_COLOR, COMPONENT_OUTLINE_BORDER, } from "../theme/componentBorders";
import { UploadOutlined, FileImageOutlined } from "@ant-design/icons";
const { Text } = Typography;
const SvgIconUpload = ({ value, onChange }) => {
    const { message } = App.useApp();
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState("");
    const handleUpload = (file) => {
        // 验证文件类型
        if (file.type !== "image/svg+xml" && !file.name.endsWith(".svg")) {
            message.error("只支持SVG格式的图标文件！");
            return false;
        }
        // 验证文件大小（限制在50KB内）
        if (file.size > 50 * 1024) {
            message.error("SVG文件大小不能超过50KB！");
            return false;
        }
        setLoading(true);
        setFileName(file.name);
        // 读取文件内容
        const reader = new FileReader();
        reader.onload = (e) => {
            let svgContent = e.target?.result;
            try {
                // 清理和验证SVG内容
                svgContent = cleanSvgContent(svgContent);
                if (onChange) {
                    onChange(svgContent);
                }
                setLoading(false);
                message.success("SVG图标上传成功");
            }
            catch (error) {
                setLoading(false);
                setFileName("");
                message.error("SVG格式无效，请检查文件内容");
            }
        };
        reader.onerror = () => {
            setLoading(false);
            setFileName("");
            message.error("读取文件失败");
        };
        reader.readAsText(file);
        return false; // 阻止默认上传
    };
    // 清理SVG内容
    const cleanSvgContent = (svgContent) => {
        // 移除BOM和多余的空白字符
        svgContent = svgContent.replace(/^\uFEFF/, "").trim();
        // 验证是否是有效的SVG
        if (!svgContent.includes("<svg") || !svgContent.includes("</svg>")) {
            throw new Error("无效的SVG格式");
        }
        // 移除可能的危险属性和脚本
        svgContent = svgContent
            .replace(/on\w+="[^"]*"/gi, "") // 移除事件处理器
            .replace(/javascript:/gi, "") // 移除javascript协议
            .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "") // 移除script标签
            .replace(/style="[^"]*javascript[^"]*"/gi, ""); // 移除包含javascript的style
        // 确保SVG有viewBox或width/height
        if (!svgContent.includes("viewBox") &&
            !svgContent.includes("width") &&
            !svgContent.includes("height")) {
            // 添加默认的viewBox
            svgContent = svgContent.replace("<svg", '<svg viewBox="0 0 24 24"');
        }
        return svgContent;
    };
    const handleClear = () => {
        onChange?.("");
        setFileName("");
    };
    return (_jsxs("div", { style: { width: "100%" }, children: [_jsxs(Row, { justify: "space-between", style: { marginBottom: 12 }, children: [_jsx(Col, { children: _jsx(Upload, { accept: ".svg,image/svg+xml", showUploadList: false, beforeUpload: handleUpload, children: _jsx(Button, { icon: _jsx(UploadOutlined, {}), loading: loading, type: "default", children: "\u4E0A\u4F20SVG" }) }) }), _jsx(Col, { children: value && (_jsx(Button, { onClick: handleClear, type: "text", danger: true, children: "\u6E05\u9664" })) })] }), _jsx("div", { style: {
                    marginBottom: 12,
                    minHeight: "20px",
                    display: "flex",
                    alignItems: "center",
                }, children: fileName && (_jsx(Text, { type: "secondary", style: { fontSize: "13px" }, children: fileName })) }), _jsx("div", { className: "svg-upload-preview", style: {
                    width: "calc(100% - 16px)",
                    height: "80px",
                    border: COMPONENT_OUTLINE_BORDER,
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    paddingLeft: "16px",
                    backgroundColor: "#fafafa",
                }, children: value ? (_jsx("div", { className: "tag-icon-container", dangerouslySetInnerHTML: { __html: value }, style: {
                        width: 48,
                        height: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    } })) : (_jsx(FileImageOutlined, { style: { color: COMPONENT_BORDER_COLOR, fontSize: 48 } })) })] }));
};
export default SvgIconUpload;
